(function () {
  var ASSETS = (window.am2pmNewsletterAssets || {});

  function iconEnvelope() {
    var span = document.createElement('span');
    span.className = 'am2pm-newsletter-confirmation__linkIcon';
    span.setAttribute('aria-hidden', 'true');
    span.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round" focusable="false">' +
      '<rect x="2.5" y="5" width="19" height="14" rx="2"/>' +
      '<path d="m3 6.5 9 6.5 9-6.5"/></svg>';
    return span;
  }

  function build(container, opts) {
    var media = document.createElement('div');
    media.className = 'am2pm-newsletter-confirmation__media';
    if (opts.illustration) {
      var img = document.createElement('img');
      img.src = opts.illustration;
      img.alt = '';
      img.width = 320;
      img.height = 320;
      img.setAttribute('aria-hidden', 'true');
      media.appendChild(img);
    }

    var body = document.createElement('div');
    body.className = 'am2pm-newsletter-confirmation__body';

    var title = document.createElement('h1');
    title.className = 'am2pm-newsletter-confirmation__title';
    title.textContent = opts.title;
    body.appendChild(title);

    opts.paragraphs.forEach(function (text) {
      var p = document.createElement('p');
      p.className = 'am2pm-newsletter-confirmation__copy';
      p.textContent = text;
      body.appendChild(p);
    });

    if (opts.action) {
      opts.action.textContent = opts.actionLabel;
      opts.action.className = 'am2pm-newsletter-confirmation__link';
      opts.action.insertBefore(iconEnvelope(), opts.action.firstChild);
      body.appendChild(opts.action);
    }

    container.replaceChildren(media, body);
    container.classList.add('am2pm-newsletter-confirmation');
    document.body.classList.add('am2pm-newsletter-page');
  }

  function findAction(container, needles) {
    return Array.prototype.slice.call(container.querySelectorAll('a')).find(function (link) {
      var label = (link.textContent || '').toLowerCase();
      var href = (link.getAttribute('href') || '').toLowerCase();
      return needles.some(function (n) { return label.indexOf(n) !== -1 || href.indexOf(n) !== -1; });
    });
  }

  function customize() {
    var container = document.querySelector('.shopify-email-marketing-confirmation__container');
    if (!container || container.classList.contains('am2pm-newsletter-confirmation')) return;

    var text = (container.textContent || '').toLowerCase();
    // Shopify serves both states from the same container; the unsubscribe page has
    // no action link left, the confirmation page still offers "Abmelden".
    var action = findAction(container, ['abmelden', 'unsubscribe']);
    var isUnsubscribed = !action && (text.indexOf('abgemeldet') !== -1 || text.indexOf('unsubscribed') !== -1);

    if (action) {
      build(container, {
        illustration: ASSETS.confirm,
        title: 'Vielen Dank für Ihre Anmeldung!',
        paragraphs: [
          'Ihre Newsletter-Anmeldung wurde erfolgreich bestätigt. Ab sofort erhalten Sie regelmässig exklusive Angebote, Neuigkeiten und ausgewählte Highlights von am2pm.ch direkt per E-Mail.',
          'Falls Sie sich später wieder abmelden möchten, ist das jederzeit mit nur einem Klick möglich.'
        ],
        action: action,
        actionLabel: 'Newsletter abmelden'
      });
    } else if (isUnsubscribed) {
      build(container, {
        illustration: ASSETS.unsubscribe,
        title: 'Du hast dich erfolgreich vom Newsletter abgemeldet',
        paragraphs: [
          'Schade, dass du gehst. Du erhältst ab sofort keine Newsletter, Aktionen oder Marketing-Updates mehr von uns.',
          'Falls du es dir anders überlegst, kannst du dich jederzeit ganz einfach wieder anmelden und weiterhin von exklusiven Rabatten, Aktionen und Angeboten profitieren.'
        ]
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', customize);
  } else {
    customize();
  }
})();
